export enum CloudFunction {
  createAuthenticationTokenForLoginToken = 'createAuthenticationTokenForLoginToken',
  createLoginWithCodeToken = 'createLoginWithCodeToken',
  createAiAgentLoginToken = 'createAiAgentLoginToken',
  joinTeam = 'joinTeam',
  getTeamsByIds = 'getTeamsByIds',
  deleteUser = 'deleteUser',
  triggerReflectionEmail = 'triggerReflectionEmail',
  createReflection = 'createReflection',
  updateReflection = 'updateReflection',
  getReflection = 'getReflection',
  getReflections = 'getReflections',
  deleteReflection = 'deleteReflection',
  archiveReflection = 'archiveReflection',
  generateReflectionData = 'generateReflectionData',
  sendReflectionCommitments = 'sendReflectionCommitments',
  getReflectionScopeData = 'getReflectionScopeData',
  setCustomUserClaimsForLoggedInUser = 'setCustomUserClaimsForLoggedInUser',
  createWherebyMeeting = 'createWherebyMeeting',
  ensureActivityWherebyMeeting = 'ensureActivityWherebyMeeting',
  getActivityWherebyMeeting = 'getActivityWherebyMeeting',
  ensureSprintActivityWherebyMeeting = 'ensureSprintActivityWherebyMeeting',
  getSprintActivityWherebyMeeting = 'getSprintActivityWherebyMeeting',
  getLiveWherebyRooms = 'getLiveWherebyRooms',
  getTeamWherebyMeeting = 'getTeamWherebyMeeting',
  getSprint = 'getSprint',
  getSprints = 'getSprints',
  createDraftSprint = 'createDraftSprint',
  updateSprint = 'updateSprint',
  deleteSprint = 'deleteSprint',
  sendSprintActivityReminder = 'sendSprintActivityReminder',
  sendSprintFeedbackReminder = 'sendSprintFeedbackReminder',
  getUser = 'getUser',
  getUsers = 'getUsers',
  updateUser = 'updateUser',
  getSessionForGroupAndTeam = 'getSessionForGroupAndTeam',
  getUpcomingActivities = 'getUpcomingActivities',
  getFacilitatorLiveSessionMonitor = 'getFacilitatorLiveSessionMonitor',
  getFacilitatorGameCallLink = 'getFacilitatorGameCallLink',
  getFacilitatorSprintCallLink = 'getFacilitatorSprintCallLink',
  getPlatformOrganizationDefaults = 'getPlatformOrganizationDefaults',
  getUpcomingActivityForGamer = 'getUpcomingActivityForGamer',
  getSkimmerDataForGamer = 'getSkimmerDataForGamer',
  getSwimmerTeamDataForGamer = 'getSwimmerTeamDataForGamer',
  getSwimmerIndividualDataForGamer = 'getSwimmerIndividualDataForGamer',
  getIndividualSessionFeedbackForGamer = 'getIndividualSessionFeedbackForGamer',
  generateReportData = 'generateReportData',
  finalizeReport = 'finalizeReport',
  getReports = 'getReports',
  getReport = 'getReport',
  updateReport = 'updateReport',
  deleteReport = 'deleteReport',
  backofficeInviteUsers = 'backofficeInviteUsers',
  boCreateUser = 'boCreateUser',
  changeUserEmail = 'changeUserEmail',
  bootstrapDefaultOrg = 'bootstrapDefaultOrg',
  getUserAchievements = 'getUserAchievements',
  markAchievementsSeen = 'markAchievementsSeen',
  unseeAllAchievements = 'unseeAllAchievements',
  getUserProfileReport = 'getUserProfileReport',
  listTeamsForWherebyRerun = 'listTeamsForWherebyRerun',
  rerunWherebyTasksForTeamIds = 'rerunWherebyTasksForTeamIds',
  upsertWherebyTaskFromEvent = 'upsertWherebyTaskFromEvent',
  getProcessingTasksOverview = 'getProcessingTasksOverview',
  retriggerWherebyTask = 'retriggerWherebyTask',
  retriggerAICoachPregeneration = 'retriggerAICoachPregeneration',
  closeGameSession = 'closeGameSession',
  endSprintActivity = 'endSprintActivity',
  setSprintIssuesReported = 'setSprintIssuesReported',
  getAriaUsageByOrganization = 'getAriaUsageByOrganization',
  endSprintActivityForTeam = 'endSprintActivityForTeam',
  sendTeamToActivity = 'sendTeamToActivity',
  getAICoachSession = 'getAICoachSession',
  triggerAICoach = 'triggerAICoach',
  replayAICoach = 'replayAICoach',
  askAppAssistant = 'askAppAssistant',
  getAssistantUserStatus = 'getAssistantUserStatus',
  mintAssistantLiveToken = 'mintAssistantLiveToken',
  escalateAssistantIssue = 'escalateAssistantIssue',
  getAssistantEscalations = 'getAssistantEscalations',
  getAssistantEscalation = 'getAssistantEscalation',
  replyToAssistantEscalation = 'replyToAssistantEscalation',
  sendAssistantSupportMessage = 'sendAssistantSupportMessage',
  resolveAssistantSupportRequest = 'resolveAssistantSupportRequest',
  markAssistantSupportRepliesRead = 'markAssistantSupportRepliesRead',
  appendAssistantTurns = 'appendAssistantTurns',
  getCoachStatus = 'getCoachStatus',
  mintCoachLiveToken = 'mintCoachLiveToken',
  startCoachConversation = 'startCoachConversation',
  sendCoachMessage = 'sendCoachMessage',
  appendCoachVoiceTurns = 'appendCoachVoiceTurns',
  endCoachConversation = 'endCoachConversation',
  getCoachConversations = 'getCoachConversations',
  getCoachConversation = 'getCoachConversation',
  getUserGoals = 'getUserGoals',
  saveUserGoals = 'saveUserGoals',
  rememberForLater = 'rememberForLater',
  updateUserGoal = 'updateUserGoal',
  deleteUserGoal = 'deleteUserGoal',
  requestGoalSetting = 'requestGoalSetting',
  getLeaderScope = 'getLeaderScope',
  setLeaderScope = 'setLeaderScope',
  getLeaderInsights = 'getLeaderInsights',
  getPlatformSettings = 'getPlatformSettings',
  updatePlatformSettings = 'updatePlatformSettings',
  getFollowUpCampaigns = 'getFollowUpCampaigns',
  generateScheduledEmail = 'generateScheduledEmail',
  getScheduledEmails = 'getScheduledEmails',
  cancelScheduledEmail = 'cancelScheduledEmail',
  rescheduleScheduledEmail = 'rescheduleScheduledEmail',
  retryScheduledEmail = 'retryScheduledEmail',
  sendScheduledEmailNow = 'sendScheduledEmailNow',
  previewFollowUpEmail = 'previewFollowUpEmail',
  getBackendEmailPreviews = 'getBackendEmailPreviews',
  getTranslations = 'getTranslations',
  updateTranslation = 'updateTranslation',
  syncMissingKeys = 'syncMissingKeys',
  sendBookDemoEmail = 'sendBookDemoEmail',
  getExpertVideos = 'getExpertVideos',
  getTutorialVideos = 'getTutorialVideos',
  getInAppNotifications = 'getInAppNotifications',
  markNotificationViewed = 'markNotificationViewed',
  markAllNotificationsViewed = 'markAllNotificationsViewed',
  sendAdminInAppNotification = 'sendAdminInAppNotification',
  createOrganization = 'createOrganization',
  updateOrganization = 'updateOrganization',
  getOrganization = 'getOrganization',
  getOrganizations = 'getOrganizations',
  inviteUserToOrganization = 'inviteUserToOrganization',
  inviteUsersToOrganization = 'inviteUsersToOrganization',
  createOrgMemberByEmail = 'createOrgMemberByEmail',
  acceptOrgInvite = 'acceptOrgInvite',
  addMember = 'addMember',
  revokeOrgInvite = 'revokeOrgInvite',
  resendOrgInvite = 'resendOrgInvite',
  setActiveOrganization = 'setActiveOrganization',
  removeUserFromOrganization = 'removeUserFromOrganization',
  updateOrgMember = 'updateOrgMember',
  getOrgInvites = 'getOrgInvites',
  getOrgMembers = 'getOrgMembers',
  deactivateOrganization = 'deactivateOrganization',
  activateOrganization = 'activateOrganization',
  reactivateOrganization = 'reactivateOrganization',
  archiveOrganization = 'archiveOrganization',
  previewDeleteOrganization = 'previewDeleteOrganization',
  deleteOrganization = 'deleteOrganization',
  reportClientError = 'reportClientError',
  getDataCustomizationCatalog = 'getDataCustomizationCatalog',
  getDataCustomizationOverview = 'getDataCustomizationOverview',
  getDataCustomizationArea = 'getDataCustomizationArea',
  saveDataCustomizationDraft = 'saveDataCustomizationDraft',
  discardDataCustomizationDraft = 'discardDataCustomizationDraft',
  rebaseDataCustomizationDraft = 'rebaseDataCustomizationDraft',
  publishDataCustomizationDraft = 'publishDataCustomizationDraft',
  getDataCustomizationVersions = 'getDataCustomizationVersions',
  loadDataCustomizationVersionIntoDraft = 'loadDataCustomizationVersionIntoDraft',
  listDataCustomizationVariants = 'listDataCustomizationVariants',
  createDataCustomizationVariant = 'createDataCustomizationVariant',
  updateDataCustomizationVariant = 'updateDataCustomizationVariant',
  archiveDataCustomizationVariant = 'archiveDataCustomizationVariant',
  restoreDataCustomizationVariant = 'restoreDataCustomizationVariant',
  deleteDataCustomizationVariant = 'deleteDataCustomizationVariant',
  setSprintActivityDataCustomizationVariant = 'setSprintActivityDataCustomizationVariant',
  searchSessionsForDataCustomizationExperiment = 'searchSessionsForDataCustomizationExperiment',
  createDataCustomizationExperiment = 'createDataCustomizationExperiment',
  listDataCustomizationExperiments = 'listDataCustomizationExperiments',
  getDataCustomizationExperiment = 'getDataCustomizationExperiment',
  getDataCustomizationExperimentResults = 'getDataCustomizationExperimentResults',
  deleteDataCustomizationExperiment = 'deleteDataCustomizationExperiment',
  startPersonalityRecalculation = 'startPersonalityRecalculation',
  getActivityVariantsForSprint = 'getActivityVariantsForSprint'
}
